// GENERATED from LumiBot's CCXT exchange catalog. Do not edit by hand.
// Regenerate: python -m lumibot.tools.ccxt_exchange_catalog --output catalog.json
// (LumiBot version/4.6.26+), then wrap the JSON as this module.
// The Node copy (botspot_node src/SavedSecrets/ccxtExchangeCatalog.generated.ts) must match;
// scripts/check-broker-consistency.js compares them.

module.exports = {
  source: 'ccxt',
  ccxtVersion: '4.5.64',
  exchanges: [
    {
      id: 'aftermath',
      name: 'AftermathFinance',
      envPrefix: 'AFTERMATH',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'AFTERMATH_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
        {
          ccxtField: 'walletAddress',
          key: 'AFTERMATH_WALLET_ADDRESS',
          label: 'Wallet Address',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'AFTERMATH_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: null,
    },
    {
      id: 'alpaca',
      name: 'Alpaca',
      envPrefix: 'ALPACA',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'ALPACA_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'ALPACA_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'ALPACA_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: true,
      docsUrl: 'https://alpaca.markets/docs/',
    },
    {
      id: 'apex',
      name: 'Apex',
      envPrefix: 'APEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'APEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'APEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'APEX_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'APEX_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api-docs.omni.apex.exchange',
    },
    {
      id: 'aster',
      name: 'Aster',
      envPrefix: 'ASTER',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'ASTER_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
      ],
      sandboxKey: 'ASTER_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/asterdex/api-docs',
    },
    {
      id: 'backpack',
      name: 'Backpack',
      envPrefix: 'BACKPACK',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BACKPACK_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BACKPACK_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BACKPACK_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.backpack.exchange/',
    },
    {
      id: 'bequant',
      name: 'Bequant',
      envPrefix: 'BEQUANT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BEQUANT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BEQUANT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BEQUANT_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api.bequant.io/',
    },
    {
      id: 'bigone',
      name: 'BigONE',
      envPrefix: 'BIGONE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BIGONE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BIGONE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BIGONE_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://open.big.one/docs/api.html',
    },
    {
      id: 'binance',
      name: 'Binance',
      envPrefix: 'BINANCE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BINANCE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BINANCE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BINANCE_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: true,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://developers.binance.com/en',
    },
    {
      id: 'binancecoinm',
      name: 'Binance COIN-M',
      envPrefix: 'BINANCECOINM',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BINANCECOINM_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BINANCECOINM_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BINANCECOINM_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://binance-docs.github.io/apidocs/delivery/en/',
    },
    {
      id: 'binanceus',
      name: 'Binance US',
      envPrefix: 'BINANCEUS',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BINANCEUS_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BINANCEUS_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BINANCEUS_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/binance-us/binance-official-api-docs',
    },
    {
      id: 'binanceusdm',
      name: 'Binance USD\u24c8-M',
      envPrefix: 'BINANCEUSDM',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BINANCEUSDM_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BINANCEUSDM_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BINANCEUSDM_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://binance-docs.github.io/apidocs/futures/en/',
    },
    {
      id: 'bingx',
      name: 'BingX',
      envPrefix: 'BINGX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BINGX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BINGX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BINGX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://bingx-api.github.io/docs/',
    },
    {
      id: 'bit2c',
      name: 'Bit2C',
      envPrefix: 'BIT2C',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BIT2C_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BIT2C_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BIT2C_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://www.bit2c.co.il/home/api',
    },
    {
      id: 'bitbank',
      name: 'bitbank',
      envPrefix: 'BITBANK',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITBANK_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITBANK_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITBANK_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.bitbank.cc/',
    },
    {
      id: 'bitbns',
      name: 'Bitbns',
      envPrefix: 'BITBNS',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITBNS_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITBNS_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITBNS_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://bitbns.com/trade/#/api-trading/',
    },
    {
      id: 'bitfinex',
      name: 'Bitfinex',
      envPrefix: 'BITFINEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITFINEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITFINEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITFINEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.bitfinex.com/v2/docs/',
    },
    {
      id: 'bitflyer',
      name: 'bitFlyer',
      envPrefix: 'BITFLYER',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITFLYER_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITFLYER_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITFLYER_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://lightning.bitflyer.com/docs?lang=en',
    },
    {
      id: 'bitget',
      name: 'Bitget',
      envPrefix: 'BITGET',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITGET_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITGET_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'BITGET_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITGET_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.bitget.com/api-doc/common/intro',
    },
    {
      id: 'bithumb',
      name: 'Bithumb',
      envPrefix: 'BITHUMB',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITHUMB_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITHUMB_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITHUMB_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://apidocs.bithumb.com',
    },
    {
      id: 'bitmart',
      name: 'BitMart',
      envPrefix: 'BITMART',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITMART_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITMART_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'uid',
          key: 'BITMART_UID',
          label: 'User ID',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'BITMART_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://developer-pro.bitmart.com/',
    },
    {
      id: 'bitmex',
      name: 'BitMEX',
      envPrefix: 'BITMEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITMEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITMEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITMEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.bitmex.com/app/apiOverview',
    },
    {
      id: 'bitopro',
      name: 'BitoPro',
      envPrefix: 'BITOPRO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITOPRO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITOPRO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITOPRO_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/bitoex/bitopro-offical-api-docs/blob/master/v3-1/rest-1/rest.md',
    },
    {
      id: 'bitrue',
      name: 'Bitrue',
      envPrefix: 'BITRUE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITRUE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITRUE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITRUE_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/Bitrue-exchange/bitrue-official-api-docs',
    },
    {
      id: 'bitso',
      name: 'Bitso',
      envPrefix: 'BITSO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITSO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITSO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITSO_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://bitso.com/api_info',
    },
    {
      id: 'bitstamp',
      name: 'Bitstamp',
      envPrefix: 'BITSTAMP',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITSTAMP_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITSTAMP_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITSTAMP_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.bitstamp.net/api',
    },
    {
      id: 'bitteam',
      name: 'BIT.TEAM',
      envPrefix: 'BITTEAM',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITTEAM_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITTEAM_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITTEAM_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://bit.team/trade/api/documentation',
    },
    {
      id: 'bittrade',
      name: 'BitTrade',
      envPrefix: 'BITTRADE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITTRADE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITTRADE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITTRADE_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api-doc.bittrade.co.jp',
    },
    {
      id: 'bitvavo',
      name: 'Bitvavo',
      envPrefix: 'BITVAVO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BITVAVO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BITVAVO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BITVAVO_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.bitvavo.com/',
    },
    {
      id: 'blockchaincom',
      name: 'Blockchain.com',
      envPrefix: 'BLOCKCHAINCOM',
      credentialFields: [
        {
          ccxtField: 'secret',
          key: 'BLOCKCHAINCOM_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BLOCKCHAINCOM_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://api.blockchain.com/v3',
    },
    {
      id: 'blofin',
      name: 'BloFin',
      envPrefix: 'BLOFIN',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BLOFIN_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BLOFIN_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'BLOFIN_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BLOFIN_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://blofin.com/docs',
    },
    {
      id: 'btcbox',
      name: 'BtcBox',
      envPrefix: 'BTCBOX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BTCBOX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BTCBOX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BTCBOX_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://blog.btcbox.jp/en/archives/8762',
    },
    {
      id: 'btcmarkets',
      name: 'BTC Markets',
      envPrefix: 'BTCMARKETS',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BTCMARKETS_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BTCMARKETS_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BTCMARKETS_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api.btcmarkets.net/doc/v3',
    },
    {
      id: 'btcturk',
      name: 'BTCTurk',
      envPrefix: 'BTCTURK',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BTCTURK_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BTCTURK_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BTCTURK_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/BTCTrader/broker-api-docs',
    },
    {
      id: 'bullish',
      name: 'Bullish',
      envPrefix: 'BULLISH',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BULLISH_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BULLISH_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BULLISH_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api.exchange.bullish.com/docs/api/rest/',
    },
    {
      id: 'bybit',
      name: 'Bybit',
      envPrefix: 'BYBIT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BYBIT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BYBIT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BYBIT_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: true,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://bybit-exchange.github.io/docs/inverse/',
    },
    {
      id: 'bybiteu',
      name: 'Bybit EU',
      envPrefix: 'BYBITEU',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BYBITEU_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BYBITEU_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BYBITEU_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://bybit-exchange.github.io/docs/inverse/',
    },
    {
      id: 'bydfi',
      name: 'BYDFi',
      envPrefix: 'BYDFI',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'BYDFI_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'BYDFI_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'BYDFI_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: false,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://developers.bydfi.com/en/',
    },
    {
      id: 'cex',
      name: 'CEX.IO',
      envPrefix: 'CEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'CEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'CEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'CEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://trade.cex.io/docs/',
    },
    {
      id: 'coinbase',
      name: 'Coinbase Advanced',
      envPrefix: 'COINBASE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINBASE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINBASE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINBASE_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.cdp.coinbase.com/coinbase-app/introduction/welcome',
    },
    {
      id: 'coinbaseexchange',
      name: 'Coinbase Exchange',
      envPrefix: 'COINBASEEXCHANGE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINBASEEXCHANGE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINBASEEXCHANGE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'COINBASEEXCHANGE_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINBASEEXCHANGE_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.cloud.coinbase.com/exchange/docs/',
    },
    {
      id: 'coinbaseinternational',
      name: 'Coinbase International',
      envPrefix: 'COINBASEINTERNATIONAL',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINBASEINTERNATIONAL_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINBASEINTERNATIONAL_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'COINBASEINTERNATIONAL_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINBASEINTERNATIONAL_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.cloud.coinbase.com/intx/docs',
    },
    {
      id: 'coincheck',
      name: 'Coincheck',
      envPrefix: 'COINCHECK',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINCHECK_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINCHECK_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINCHECK_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://coincheck.com/documents/exchange/api',
    },
    {
      id: 'coinex',
      name: 'CoinEx',
      envPrefix: 'COINEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.coinex.com/api/v2',
    },
    {
      id: 'coinmate',
      name: 'CoinMate',
      envPrefix: 'COINMATE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINMATE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINMATE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'uid',
          key: 'COINMATE_UID',
          label: 'User ID',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'COINMATE_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://coinmate.docs.apiary.io',
    },
    {
      id: 'coinone',
      name: 'CoinOne',
      envPrefix: 'COINONE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINONE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINONE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINONE_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://doc.coinone.co.kr',
    },
    {
      id: 'coinsph',
      name: 'Coins.ph',
      envPrefix: 'COINSPH',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINSPH_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINSPH_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINSPH_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://coins-docs.github.io/rest-api',
    },
    {
      id: 'coinspot',
      name: 'CoinSpot',
      envPrefix: 'COINSPOT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'COINSPOT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'COINSPOT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'COINSPOT_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://www.coinspot.com.au/api',
    },
    {
      id: 'cryptocom',
      name: 'Crypto.com',
      envPrefix: 'CRYPTOCOM',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'CRYPTOCOM_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'CRYPTOCOM_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'CRYPTOCOM_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: true,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://exchange-docs.crypto.com/exchange/v1/rest-ws/index.html',
    },
    {
      id: 'cryptomus',
      name: 'Cryptomus',
      envPrefix: 'CRYPTOMUS',
      credentialFields: [
        {
          ccxtField: 'secret',
          key: 'CRYPTOMUS_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'uid',
          key: 'CRYPTOMUS_UID',
          label: 'User ID',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'CRYPTOMUS_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: false,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://doc.cryptomus.com/personal',
    },
    {
      id: 'deepcoin',
      name: 'DeepCoin',
      envPrefix: 'DEEPCOIN',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'DEEPCOIN_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'DEEPCOIN_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'DEEPCOIN_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'DEEPCOIN_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: false,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.deepcoin.com/docs',
    },
    {
      id: 'delta',
      name: 'Delta Exchange',
      envPrefix: 'DELTA',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'DELTA_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'DELTA_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'DELTA_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: true,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.delta.exchange',
    },
    {
      id: 'deribit',
      name: 'Deribit',
      envPrefix: 'DERIBIT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'DERIBIT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'DERIBIT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'DERIBIT_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: true,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.deribit.com/v2',
    },
    {
      id: 'derive',
      name: 'Derive',
      envPrefix: 'DERIVE',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'DERIVE_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
        {
          ccxtField: 'walletAddress',
          key: 'DERIVE_WALLET_ADDRESS',
          label: 'Wallet Address',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'DERIVE_SANDBOX',
      capabilities: {
        spot: false,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://docs.derive.xyz/docs/',
    },
    {
      id: 'digifinex',
      name: 'DigiFinex',
      envPrefix: 'DIGIFINEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'DIGIFINEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'DIGIFINEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'DIGIFINEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.digifinex.com',
    },
    {
      id: 'dydx',
      name: 'dYdX',
      envPrefix: 'DYDX',
      credentialFields: [],
      sandboxKey: 'DYDX_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: false,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.dydx.xyz',
    },
    {
      id: 'exmo',
      name: 'EXMO',
      envPrefix: 'EXMO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'EXMO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'EXMO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'EXMO_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://exmo.me/en/api_doc?ref=131685',
    },
    {
      id: 'extended',
      name: 'Extended',
      envPrefix: 'EXTENDED',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'EXTENDED_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'privateKey',
          key: 'EXTENDED_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
      ],
      sandboxKey: 'EXTENDED_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api.docs.extended.exchange',
    },
    {
      id: 'fmfwio',
      name: 'FMFW.io',
      envPrefix: 'FMFWIO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'FMFWIO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'FMFWIO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'FMFWIO_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api.fmfw.io/',
    },
    {
      id: 'foxbit',
      name: 'Foxbit',
      envPrefix: 'FOXBIT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'FOXBIT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'FOXBIT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'FOXBIT_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.foxbit.com.br',
    },
    {
      id: 'gate',
      name: 'Gate',
      envPrefix: 'GATE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'GATE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'GATE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'GATE_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: true,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.gate.com/docs/developers/apiv4/en',
    },
    {
      id: 'gateeu',
      name: 'Gate EU',
      envPrefix: 'GATEEU',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'GATEEU_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'GATEEU_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'GATEEU_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.gate.com/docs/developers/apiv4/en',
    },
    {
      id: 'gemini',
      name: 'Gemini',
      envPrefix: 'GEMINI',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'GEMINI_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'GEMINI_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'GEMINI_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.gemini.com/rest-api',
    },
    {
      id: 'grvt',
      name: 'GRVT',
      envPrefix: 'GRVT',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'GRVT_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
      ],
      sandboxKey: 'GRVT_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api-docs.grvt.io/',
    },
    {
      id: 'hashkey',
      name: 'HashKey Global',
      envPrefix: 'HASHKEY',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'HASHKEY_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'HASHKEY_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'HASHKEY_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://hashkeyglobal-apidoc.readme.io/',
    },
    {
      id: 'hibachi',
      name: 'Hibachi',
      envPrefix: 'HIBACHI',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'HIBACHI_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'accountId',
          key: 'HIBACHI_ACCOUNT_ID',
          label: 'Account ID',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'privateKey',
          key: 'HIBACHI_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
      ],
      sandboxKey: 'HIBACHI_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: null,
    },
    {
      id: 'hitbtc',
      name: 'HitBTC',
      envPrefix: 'HITBTC',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'HITBTC_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'HITBTC_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'HITBTC_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api.hitbtc.com',
    },
    {
      id: 'hollaex',
      name: 'HollaEx',
      envPrefix: 'HOLLAEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'HOLLAEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'HOLLAEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'HOLLAEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://apidocs.hollaex.com',
    },
    {
      id: 'htx',
      name: 'HTX',
      envPrefix: 'HTX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'HTX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'HTX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'HTX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://huobiapi.github.io/docs/spot/v1/en/',
    },
    {
      id: 'hyperliquid',
      name: 'Hyperliquid',
      envPrefix: 'HYPERLIQUID',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'HYPERLIQUID_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
        {
          ccxtField: 'walletAddress',
          key: 'HYPERLIQUID_WALLET_ADDRESS',
          label: 'Wallet Address',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'HYPERLIQUID_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://hyperliquid.gitbook.io/hyperliquid-docs/for-developers/api',
    },
    {
      id: 'independentreserve',
      name: 'Independent Reserve',
      envPrefix: 'INDEPENDENTRESERVE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'INDEPENDENTRESERVE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'INDEPENDENTRESERVE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'INDEPENDENTRESERVE_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://www.independentreserve.com/API',
    },
    {
      id: 'indodax',
      name: 'INDODAX',
      envPrefix: 'INDODAX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'INDODAX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'INDODAX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'INDODAX_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/btcid/indodax-official-api-docs',
    },
    {
      id: 'kraken',
      name: 'Kraken',
      envPrefix: 'KRAKEN',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'KRAKEN_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'KRAKEN_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'KRAKEN_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.kraken.com/rest/',
    },
    {
      id: 'krakenfutures',
      name: 'Kraken Futures',
      envPrefix: 'KRAKENFUTURES',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'KRAKENFUTURES_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'KRAKENFUTURES_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'KRAKENFUTURES_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.kraken.com/api/docs/futures-api/trading/market-data/',
    },
    {
      id: 'kucoin',
      name: 'KuCoin',
      envPrefix: 'KUCOIN',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'KUCOIN_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'KUCOIN_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'KUCOIN_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'KUCOIN_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.kucoin.com',
    },
    {
      id: 'kucoineu',
      name: 'KuCoin EU',
      envPrefix: 'KUCOINEU',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'KUCOINEU_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'KUCOINEU_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'KUCOINEU_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'KUCOINEU_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.kucoin.com/en-eu/docs-new',
    },
    {
      id: 'kucoinfutures',
      name: 'KuCoin Futures',
      envPrefix: 'KUCOINFUTURES',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'KUCOINFUTURES_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'KUCOINFUTURES_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'KUCOINFUTURES_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'KUCOINFUTURES_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.kucoin.com',
    },
    {
      id: 'latoken',
      name: 'Latoken',
      envPrefix: 'LATOKEN',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'LATOKEN_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'LATOKEN_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'LATOKEN_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://api.latoken.com',
    },
    {
      id: 'lbank',
      name: 'LBank',
      envPrefix: 'LBANK',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'LBANK_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'LBANK_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'LBANK_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.lbank.com/en-US/docs/index.html',
    },
    {
      id: 'lighter',
      name: 'Lighter',
      envPrefix: 'LIGHTER',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'LIGHTER_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
      ],
      sandboxKey: 'LIGHTER_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://apidocs.lighter.xyz/',
    },
    {
      id: 'luno',
      name: 'Luno',
      envPrefix: 'LUNO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'LUNO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'LUNO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'LUNO_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.luno.com/en/api',
    },
    {
      id: 'mercado',
      name: 'Mercado Bitcoin',
      envPrefix: 'MERCADO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'MERCADO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'MERCADO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'MERCADO_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.mercadobitcoin.com.br/api-doc',
    },
    {
      id: 'mexc',
      name: 'MEXC Global',
      envPrefix: 'MEXC',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'MEXC_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'MEXC_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'MEXC_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://mexcdevelop.github.io/apidocs/',
    },
    {
      id: 'modetrade',
      name: 'Mode Trade',
      envPrefix: 'MODETRADE',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'MODETRADE_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'MODETRADE_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'accountId',
          key: 'MODETRADE_ACCOUNT_ID',
          label: 'Account ID',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'MODETRADE_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: false,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: null,
    },
    {
      id: 'mudrex',
      name: 'Mudrex',
      envPrefix: 'MUDREX',
      credentialFields: [
        {
          ccxtField: 'secret',
          key: 'MUDREX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'MUDREX_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.trade.mudrex.com/docs',
    },
    {
      id: 'myokx',
      name: 'MyOKX(EEA)',
      envPrefix: 'MYOKX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'MYOKX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'MYOKX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'MYOKX_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'MYOKX_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://my.okx.com/docs-v5/en/#overview',
    },
    {
      id: 'ndax',
      name: 'NDAX',
      envPrefix: 'NDAX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'NDAX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'NDAX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'NDAX_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'uid',
          key: 'NDAX_UID',
          label: 'User ID',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'login',
          key: 'NDAX_LOGIN',
          label: 'Login',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'NDAX_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://apidoc.ndax.io/',
    },
    {
      id: 'okx',
      name: 'OKX',
      envPrefix: 'OKX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'OKX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'OKX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'OKX_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'OKX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: true,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.okx.com/docs-v5/en/',
    },
    {
      id: 'okxus',
      name: 'OKX(US)',
      envPrefix: 'OKXUS',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'OKXUS_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'OKXUS_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'OKXUS_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'OKXUS_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://app.okx.com/docs-v5/en/#overview',
    },
    {
      id: 'onetrading',
      name: 'One Trading',
      envPrefix: 'ONETRADING',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'ONETRADING_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'ONETRADING_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.onetrading.com',
    },
    {
      id: 'p2b',
      name: 'p2b',
      envPrefix: 'P2B',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'P2B_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'P2B_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'P2B_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/P2B-team/p2b-api-docs/blob/master/api-doc.md',
    },
    {
      id: 'pacifica',
      name: 'Pacifica',
      envPrefix: 'PACIFICA',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'PACIFICA_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
      ],
      sandboxKey: 'PACIFICA_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.pacifica.fi/api-documentation/api/rest-api',
    },
    {
      id: 'paradex',
      name: 'Paradex',
      envPrefix: 'PARADEX',
      credentialFields: [
        {
          ccxtField: 'privateKey',
          key: 'PARADEX_PRIVATE_KEY',
          label: 'Private Key',
          secret: true,
          multiline: true,
        },
        {
          ccxtField: 'walletAddress',
          key: 'PARADEX_WALLET_ADDRESS',
          label: 'Wallet Address',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'PARADEX_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.api.testnet.paradex.trade/',
    },
    {
      id: 'paymium',
      name: 'Paymium',
      envPrefix: 'PAYMIUM',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'PAYMIUM_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'PAYMIUM_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'PAYMIUM_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/Paymium/api-documentation',
    },
    {
      id: 'phemex',
      name: 'Phemex',
      envPrefix: 'PHEMEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'PHEMEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'PHEMEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'PHEMEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://phemex-docs.github.io/#overview',
    },
    {
      id: 'poloniex',
      name: 'Poloniex',
      envPrefix: 'POLONIEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'POLONIEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'POLONIEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'POLONIEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://api-docs.poloniex.com/spot/',
    },
    {
      id: 'tokocrypto',
      name: 'Tokocrypto',
      envPrefix: 'TOKOCRYPTO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'TOKOCRYPTO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'TOKOCRYPTO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'TOKOCRYPTO_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: false,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.tokocrypto.com/apidocs/',
    },
    {
      id: 'toobit',
      name: 'Toobit',
      envPrefix: 'TOOBIT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'TOOBIT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'TOOBIT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'TOOBIT_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://toobit-docs.github.io/apidocs/spot/v1/en/',
    },
    {
      id: 'upbit',
      name: 'Upbit',
      envPrefix: 'UPBIT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'UPBIT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'UPBIT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'UPBIT_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.upbit.com/kr',
    },
    {
      id: 'weex',
      name: 'Weex',
      envPrefix: 'WEEX',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'WEEX_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'WEEX_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'password',
          key: 'WEEX_API_PASSPHRASE',
          label: 'API Passphrase',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'WEEX_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://www.weex.com/api-doc',
    },
    {
      id: 'whitebit',
      name: 'WhiteBit',
      envPrefix: 'WHITEBIT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'WHITEBIT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'WHITEBIT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'WHITEBIT_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/whitebit-exchange/api-docs',
    },
    {
      id: 'woo',
      name: 'WOO X',
      envPrefix: 'WOO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'WOO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'WOO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'WOO_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: false,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://docs.woox.io/',
    },
    {
      id: 'woofipro',
      name: 'WOOFI PRO',
      envPrefix: 'WOOFIPRO',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'WOOFIPRO_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'WOOFIPRO_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
        {
          ccxtField: 'accountId',
          key: 'WOOFIPRO_ACCOUNT_ID',
          label: 'Account ID',
          secret: false,
          multiline: false,
        },
      ],
      sandboxKey: 'WOOFIPRO_SANDBOX',
      capabilities: {
        spot: false,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: false,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: true,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://orderly.network/docs/build-on-omnichain/building-on-evm',
    },
    {
      id: 'xt',
      name: 'XT',
      envPrefix: 'XT',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'XT_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'XT_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'XT_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: true,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://doc.xt.com/',
    },
    {
      id: 'zaif',
      name: 'Zaif',
      envPrefix: 'ZAIF',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'ZAIF_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'ZAIF_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'ZAIF_SANDBOX',
      capabilities: {
        spot: true,
        swap: false,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: false,
        fetchTicker: true,
        fetchPositions: false,
        watchOrders: false,
        sandbox: false,
        dex: false,
      },
      supportLevel: 'trading_no_history',
      nativeNameCollision: false,
      docsUrl: 'https://techbureau-api-document.readthedocs.io/ja/latest/index.html',
    },
    {
      id: 'zebpay',
      name: 'Zebpay',
      envPrefix: 'ZEBPAY',
      credentialFields: [
        {
          ccxtField: 'apiKey',
          key: 'ZEBPAY_API_KEY',
          label: 'API Key',
          secret: false,
          multiline: false,
        },
        {
          ccxtField: 'secret',
          key: 'ZEBPAY_API_SECRET',
          label: 'API Secret',
          secret: true,
          multiline: false,
        },
      ],
      sandboxKey: 'ZEBPAY_SANDBOX',
      capabilities: {
        spot: true,
        swap: true,
        future: false,
        option: false,
        createOrder: true,
        cancelOrder: true,
        fetchBalance: true,
        fetchOHLCV: true,
        fetchTicker: true,
        fetchPositions: true,
        watchOrders: false,
        sandbox: true,
        dex: false,
      },
      supportLevel: 'trading',
      nativeNameCollision: false,
      docsUrl: 'https://github.com/zebpay/zebpay-api-references',
    },
  ],
};
